// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"6":"e524f7f3","167":"9aec5e32","226":"823b6df8","303":"534b19d0","427":"5a1b5dbb","632":"b23c42e4","794":"e67059d2","823":"cb8bbdca","880":"18cfd1c2","964":"cce7a640"}[chunkId] + ".chunk.js";
};